export default "__VITE_ASSET__D5HEw_SA__"